<template>
  <div class="artisio-e-signature" :class="isOpen ? 'open': ''">
    <div class="wrapper">
      <canvas :id="id" class="signature-pad" width=400 height=200></canvas>
      <div class="buttons-wrapper mt-3 d-flex">
        <b-button variant="secondary" @click="close">{{$t('Cancel')}}</b-button>
        <b-button variant="secondary" @click="onClearClick" class="ml-auto">{{$t("Clear")}}</b-button>
        <b-button variant="primary" @click="onSubmitClick" class="ml-2">{{ $t('Submit') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import SignaturePad from "signature_pad";
  import {uuid} from 'vue-uuid';

  export default {
    name: "ArtisioESignature",
    data() {
      return {
        isOpen: false,
        id: uuid.v4(),
        signaturePad: null,
        resizeCanvas: null
      }
    },
    methods: {
      open() {
        this.isOpen = true;
        this.resizeCanvas()
      },
      close() {
        this.onClearClick();
        this.isOpen = false;
      },
      async onSubmitClick() {
        if (this.signaturePad.isEmpty()) {
          return alert("Please provide a signature first.");
        }

        let data = this.signaturePad.toDataURL('image/png');
        this.$emit('submit', data)
        this.close()
      },
      onClearClick() {
        this.signaturePad.clear();
      }
    },
    mounted() {
      let canvas = document.getElementById(this.id);

      // Adjust canvas coordinate space taking into account pixel ratio,
      // to make it look crisp on mobile devices.
      // This also causes canvas to be cleared.
      this.resizeCanvas = () => {
        // When zoomed out to less than 100%, for some very strange reason,
        // some browsers report devicePixelRatio as less than 1
        // and only part of the canvas is cleared then.
        const ratio =  Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);
      }

      window.onresize = this.resizeCanvas;
      this.resizeCanvas();

      this.signaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
      });
    }
  }
</script>

<style lang="scss" scoped>
  .artisio-e-signature {
    width: 0;
    height: 0;
    visibility: hidden;

    .wrapper {
      display: flex;
      align-items: center;
      flex-direction: column;

      canvas {
        border: 2px dashed #cecece;
        border-radius: 15px;
        height: 200px;
        width: 400px;
      }

      .buttons-wrapper {
        width: 400px;
      }
    }

    &.open {
      width: auto;
      height: auto;
      visibility: visible;

      padding-top: 20px;
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      background-color: white;
      right: 0;
    }
  }
</style>
